<template>
  <div :class="$style.style">
    <div class="topBox">
     <!-- <img style="width:100%;" src="https://img1.jianyewy.com/image-fa7fe394-a6f0-48b4-8982-2521bf7f0097.png" alt="">  -->
     <img style="width:100%;" :src="activityBackgroundImage" alt=""> 
    <p>{{titleText}}</p>
    <div class="gradients"></div>
    </div>
    <div class="contentDiv">
      <ul>
        <li v-for="(tab,index) in msgfromfa" :key="index">
         
            <div class="left" v-show="tab.content != '提醒文案'">
              <span v-if="tab.require == 1">*</span>{{tab.content}}:
            </div>
            <div class="right" v-if="tab.type == 'text'" v-show="tab.content != '提醒文案' && tab.content != '备注'">
              <el-input :type="tab.type" readonly></el-input>           
            </div>
            <div class="right" v-show="tab.content == '备注'">
              <!-- <el-input :type="tab.type" readonly></el-input> -->
              <textarea></textarea>           
            </div>
           
         
          <div v-show="tab.content == '提醒文案'">
            <span style="color:#999">{{tab.content}}</span>           
          </div>
          <div class="right" v-if="tab.type == 'radio'">
            <el-radio-group v-model="radio1" readonly>
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
          </div>
           <!-- <div class="right" v-if="tab.type == 'image'">
             <div class="imgDiv">
             <p class="img1">
            添加照片
          </p>         
             </div>
          </div> -->
        </li>
      </ul>
    </div>
    <!-- <div v-show='msgfromfa.length == 0' style="width:96%;height:100px;font-size:16px;
    text-align:center;margin-top:12%; color:#666">
      暂无报名选项
    </div> -->
    <div class="btn-sign">确认报名</div>
  </div>
</template>
<script>
export default {
  // props: ['msgfromfa', 'titleText', 'activityBackgroundImage'],
  data() {
    return {
      radio1: 0,
      titleText: '报名活动名称'
    };
  },
  props: {
    msgfromfa: Array,
    titleText: String,
    activityBackgroundImage: String
  }
};
</script>
<style lang="less" module>
:local(.style) {
  width: 100%;
  padding-bottom: 50px;
  position: relative;
  * {
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
  .topBox {
    position: relative;
    img {
    }
    > p {
      font-size: 18px;
      color: #fff;
      // font-weight: bolder;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 25%;
      z-index: 1;
      padding: 0 14px;
    }
    .gradients {
      width: 100%;
      height: 300px;
      background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.2));
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
  }
  input {
    width: 140px !important;
  }
  .contentDiv {
    width: 220px;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 0 0 10px #807d7d;
    position: relative;
    margin-top: -20px;
    padding-top: 2px;
    border-radius: 4px;
    z-index: 1;
    padding-bottom: 16px;
    ul {
      li:after {
        content: '.';
        display: block;
        height: 0;
        visibility: hidden;
        clear: left;
      }
      li {
        width: 200px;
        line-height: 30px;
        margin: 10px 0 10px 10px;
        padding-left: 10px;
        background-color: #f9f9f9;
        overflow: hidden;

        .left {
          float: left;
          > span {
            color: red;
          }
        }
        .right {
          float: left;
          margin-left: 10px;
        }
        .right:after {
          content: '.';
          display: block;
          height: 0;
          visibility: hidden;
          clear: left;
        }
      }
      .imgDiv {
        width: 140px;
        // height: 140px;
        // background-color: transparent;
        .img1 {
          width: 80px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          background-color: #808080;
          color: #fff;
        }
        > p:nth-child(2) {
          line-height: 20px !important;
        }
      }
      .remark {
        height: 100px;
      }
    }
  }
  .btn-sign {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background-color: #fba32e;
    position: absolute;
    bottom: 0px;
  }
}
</style>

